<template>
  <div class="container-fluid py-4">
    <h3 class="mb-4 text-center">bem vindo ao CLOCK-IN - REP</h3>

    <!-- Filtros -->
    <div class="row mb-4">
      <div class="col-md-6 mb-2">
        <label class="form-label fw-bold">Mês</label>
        <select v-model="filtros.mes" class="form-control" @change="atualizarDashboard">
          <option v-for="m in meses" :key="m">{{ m }}</option>
        </select>
      </div>
      <div class="col-md-6 mb-2">
        <label class="form-label fw-bold">Setor</label>
        <select v-model="filtros.setor" class="form-control" @change="atualizarDashboard">
          <option>Todos</option>
          <option v-for="s in setores" :key="s">{{ s }}</option>
        </select>
      </div>
    </div>

    <!-- Cards de indicadores -->
    <div class="row mb-4">
      <div class="col-md-3 col-sm-6 mb-3" v-for="(card, index) in cards" :key="index">
        <div class="card text-white shadow-sm" :style="{ backgroundColor: card.color }">
          <div class="card-body text-center">
            <h4 class="mb-2">{{ card.value }}</h4>
            <p class="m-0">{{ card.label }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="row">
      <div class="col-md-6 mb-4">
        <v-chart :option="chartHorasTrabalhadas" autoresize :manual-update="true" :resizeDelay="300" style="height: 350px;" />
      </div>
      <div class="col-md-6 mb-4">
        <v-chart :option="chartFaltasAtrasos" autoresize :manual-update="true" :resizeDelay="300" style="height: 350px;" />
      </div>
      <div class="col-md-6 mb-4">
        <v-chart :option="chartBancoDeHoras" autoresize :manual-update="true" :resizeDelay="300" style="height: 350px;" />
      </div>
      <div class="col-md-6 mb-4">
        <v-chart :option="chartPontualidade" autoresize :manual-update="true" :resizeDelay="300" style="height: 350px;" />
      </div>
    </div>
  </div>
</template>

<script>

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6);


import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, PieChart, LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts'
import Swal from 'sweetalert2'
import util from '../util.js'

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

export default {
  name: 'DashboardRh',
  components: { VChart },
  data() {
    return {
      meses: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      setores: ['Admin', 'Financeiro', 'Vendas', 'TI', 'Produção'],
      filtros: {
        mes: 'Fevereiro', // Mês atual conforme sistema
        setor: 'Todos'
      },
      cards: [],
      chartHorasTrabalhadas: {},
      chartFaltasAtrasos: {},
      chartBancoDeHoras: {},
      chartPontualidade: {}
    }
  },
  mounted() {
    // Chama a requisição assim que o componente é montado
    this.atualizarDashboard()
    
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  },
  methods: {
   async atualizarDashboard() {
        var vself = this;
        
        // 1. Mapeia o mês para o formato numérico (Ex: Janeiro -> 01)
        const mesIndex = vself.meses.indexOf(vself.filtros.mes) + 1;
        const mesFormatado = mesIndex.toString().padStart(2, '0');

        // 2. Monta os parâmetros no seu padrão [ {parametro: 'x', valor: 'y'} ]
        let parametros = [
            { parametro: 'op',        valor: 'carregadash' },
            { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
            { parametro: 'mes',       valor: mesFormatado },
            { parametro: 'ano',       valor: new Date().getFullYear() },
            { parametro: 'setor',     valor: vself.filtros.setor }
        ];

        // 3. Executa a request usando seu utilitário util.reqaxios
        let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/dashboard.php'); 
        
        retorno.then(function (response) {
            let data = response.data;

            // Atualiza os Cards
            vself.cards = data.cards;

            // Atualiza o Gráfico de Pontualidade (Pizza)
            vself.chartPontualidade = {
                title: { text: 'Pontualidade Geral', left: 'center' },
                tooltip: { trigger: 'item' },
                legend: { bottom: 0 },
                series: [{
                    type: 'pie',
                    radius: '65%',
                    data: data.pizza.map(item => {
                        if(item.name === 'Pontuais') item.itemStyle = { color: '#13534a' };
                        if(item.name === 'Atrasados') item.itemStyle = { color: '#e67e22' };
                        if(item.name === 'Faltas') item.itemStyle = { color: '#c0392b' };
                        return item;
                    })
                }]
            };

            // Atualiza o Gráfico de Horas por Setor (Barra)
            vself.chartHorasTrabalhadas = {
                title: { text: 'Horas Trabalhadas por Setor', left: 'center' },
                tooltip: {},
                xAxis: { data: data.setores },
                yAxis: { type: 'value' },
                series: [{
                    name: 'Horas Reais',
                    type: 'bar',
                    data: data.horas_setor,
                    color: '#13534a'
                }]
            };

            // Força o resize para garantir que os gráficos fiquem no tamanho certo
            vself.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });

        }).catch(function (error) {
            console.error('Erro ao carregar dashboard', error);
        });
    },

    renderizarGraficoPontualidade(dadosPizza) {
      this.chartPontualidade = {
        title: { text: 'Pontualidade Geral', left: 'center' },
        tooltip: { trigger: 'item' },
        legend: { bottom: 0 },
        series: [
          {
            type: 'pie',
            radius: '65%',
            data: dadosPizza.map(item => {
                // Aplica as cores conforme o nome vindo do PHP
                if(item.name === 'Pontuais') item.itemStyle = { color: '#13534a' };
                if(item.name === 'Atrasados') item.itemStyle = { color: '#e67e22' };
                if(item.name === 'Faltas') item.itemStyle = { color: '#c0392b' };
                return item;
            })
          }
        ]
      }
    },

    renderizarGraficoSetores(labels, valores) {
      this.chartHorasTrabalhadas = {
        title: { text: `Horas por Setor`, left: 'center' },
        tooltip: {},
        xAxis: { data: labels },
        yAxis: { type: 'value' },
        series: [
          { 
            name: 'Horas Reais', 
            type: 'bar', 
            data: valores, 
            color: '#13534a' 
          }
        ]
      }
    }
  }
}

</script>

<style scoped>
.card {
  border: none;
  border-radius: 10px;
}
h3 {
  font-weight: 600;
  color: #13534a;
}
label {
  color: #13534a;
}
.v-chart, .echarts {
  contain: layout size style;
}
</style>
